module.exports = __webpack_public_path__ + "static/media/icons.12d99fee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons.svg
// module id = 357
// module chunks = 0